export default {
  title: '404 - Страница не найдена',
  heading: '404 - Страница не найдена',
  text1: 'К сожалению, такой страницы не существует, или она была удалена. Перейти на главную ',
  text2: ' Перейти на главную',
}